export default __webpack_public_path__ + "static/media/logo_full.f3ac8f11.svg";